import React from 'react';

const PokeballIcon = ({text, darkMode, mt }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="20"
    height="20"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="1.5"
    strokeLinecap="round"
    strokeLinejoin="round"
    className={ `${text} ${darkMode} icon icon-tabler icons-tabler-outline icon-tabler-pokeball ${mt}`}
  >
    <path stroke="none" d="M0 0h24v24H0z" fill="none" />
    <path d="M12 12m-9 0a9 9 0 1 0 18 0a9 9 0 1 0 -18 0" />
    <path d="M12 12m-3 0a3 3 0 1 0 6 0a3 3 0 1 0 -6 0" />
    <path d="M3 12h6" />
    <path d="M15 12h6" />
  </svg>
);

export default PokeballIcon;
